import React from "react"

function PickOne<T>({label, items, current, change}: {label?: string, items: {key: string, val: T}[], current?: T, change?: (item: T) => void}) {
  return <div className="sandbox__pickOne">
    {label && <span>{label}</span>}
    {items.map((i) => {
      const className = [
        "sandbox__pickOne__item",
        i.val === current ? "sandbox__pickOne__item--selected" : "sandbox__pickOne__item--notSelected"
      ].join(" ")
      return <a className={className} key={i.key} onClick={() => change?.(i.val)}>{`${i.key}`}</a>
    })}
  </div>
}

export default PickOne
